import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import Constants from 'utils/Constants';
import { Switch, Route } from 'react-router-dom';
import VariableRetrievalForm from 'components/page/process/variableRetrieval/VariableRetrievalForm';
import CoordinateSystemForm from 'components/page/process/variableRetrieval/coordinateSystem/CoordinateSystemForm';
import RetrievedVariableForm from 'components/page/process/variableRetrieval/retrievedVariable/RetrievedVariableForm';
import OutputDatastreamForm from 'components/page/process/variableRetrieval/outputs/OutputDatastreamForm';
import RetrievalRulesForm from 'components/page/process/variableRetrieval/RetrievalRulesForm';
import AdvancedTransformationForm from 'components/page/process/variableRetrieval/coordinateSystem/AdvancedTransformationForm';
import OutputQC from 'components/page/process/variableRetrieval/outputs/OutputQC.js';
import InputQC from 'components/page/process/variableRetrieval/inputs/InputQC.js';
import PageDoesNotExist from 'components/core/404';

/**
 * Base component for variable retrieval forms
 */
export default class VariableRetrieval extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        exploredDatastreams: PropTypes.object,
        revisionNum: PropTypes.string,
        processErrors: PropTypes.object,
        children: PropTypes.object,
        dispatch: PropTypes.func,
        hasWritePermissions: PropTypes.bool,
        siteFacilities: PropTypes.array,
        dods: PropTypes.array,
        dodsById: PropTypes.object,
        id: PropTypes.string,
        location: PropTypes.object
    };

    constructor(props) {
        super(props);

        // copied from http://www.colourlovers.com/palette/2423756/Twitter_Bootstrap to match bootstraps's palette... ['#0044CC', '#0088CC', '#51A351', '#F89406', '#BD362F', '#0044CC', '#0088CC', '#51A351'];
        // this._coordSysColorPalette = ['#F9CDAC', '#F3ACA2', '#EE8B97', '#E96A8D', '#DB5087', '#B8428C', '#973490', '#742796', '#5E1F88', '#4D1A70', '#3D1459', '#2D0F41'];
        this._coordSysColorPalette = ['#F6B5A4', '#EB7590', '#C8488A', '#872E93', '#581D7F', '#3A1353'];
        this._coordSysColorPaletteMap = {};
        // this._outputDataStreamColorPalette = ['#FDED86', '#FDE86E', '#F9D063', '#F5B857', '#F0A04B', '#EB8A40', '#E77235', '#E35B2C', '#C74E29', '#9D4429', '#753C2C', '#4C3430'];
        this._outputDataStreamColorPalette = ['#BEE0CC', '#70C3D0', '#419DC5', '#316BA7', '#223B89', '#151E5E'];
        this._outputDataStreamColorPaletteMap = {};
        // this._inputDatasetColorPalette = ['#DCECC9', '#B3DDCC', '#8ACDCE', '#62BED2', '#46AACE', '#3D91BE', '#3577AE', '#2D5E9E', '#24448E', '#1C2B7F', '#162065', '#11174B'];
        this._inputDatasetColorPalette = ['#FDEB73', '#F6C15B', '#F9D063', '#ED9445', '#E66731', '#B84A29', '#6A3A2D'];
        this._inputDatasetColorPaletteMap = {};

        this._colorPaletteMap = {};
        this._colorPaletteMap[Constants.TYPE_COORDINATE_SYSTEM] = this._coordSysColorPaletteMap;
        this._colorPaletteMap[Constants.TYPE_INPUT_DATASET] = this._inputDatasetColorPaletteMap;
        this._colorPaletteMap[Constants.TYPE_OUTPUT_DATASTREAM] = this._outputDataStreamColorPaletteMap;

        this._colorPalettes = {};
        this._colorPalettes[Constants.TYPE_COORDINATE_SYSTEM] = this._coordSysColorPalette;
        this._colorPalettes[Constants.TYPE_INPUT_DATASET] = this._inputDatasetColorPalette;
        this._colorPalettes[Constants.TYPE_OUTPUT_DATASTREAM] = this._outputDataStreamColorPalette;
    }

    getListEntityForEvent = (e) => {
        // Get the id for the selected element
        const selectedEntity = $(e.target).closest('[data-name]');
        const entityId = selectedEntity.data('name');
        return entityId;
    };

    getBackgroundColor = (type, name) => {
        if (!this._colorPaletteMap[type][name]) {
            const length = Object.keys(this._colorPaletteMap[type]).length;
            this._colorPaletteMap[type][name] = this._colorPalettes[type][length];
        }
        if (!this._colorPaletteMap[type][name]) {
            return { }; //case where we ran out of colors from the palette so use default style's color
        }
        return { backgroundColor: this._colorPaletteMap[type][name] };
    };

    render() {
        const basePath = this.props.match.path;
        const props = {
            process: this.props.process,
            processId: this.props.processId,
            revisionNum: this.props.revisionNum,
            processErrors: this.props.processErrors,
            exploredDatastreams: this.props.exploredDatastreams,
            dispatch: this.props.dispatch,
            hasWritePermissions: this.props.hasWritePermissions,
            dods: this.props.dods,
            dodsById: this.props.dodsById,
            siteFacilities: this.props.siteFacilities,
            getListEntityForEvent: this.getListEntityForEvent,
            getOutputDatastream: this.getOutputDatastream,
            getBackgroundColor: this.getBackgroundColor,
            id: this.props.id
        };

        return (
            <div className="variable-retrieval">
                <Switch>
                    <Route path={`${basePath}/coordinate-system/:coordinateSystem/:dimension`} render={(routeProps) => <CoordinateSystemForm {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/coordinate-system/:coordinateSystem`} render={(routeProps) => <CoordinateSystemForm {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/transformations/:coordinateSystem/:dimension`} render={(routeProps) => <AdvancedTransformationForm {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/retrieved-variable/:entity`} render={(routeProps) => <RetrievedVariableForm {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/output-datastream/:entity`} render={(routeProps) => <OutputDatastreamForm {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/output-qc/:coordinateSystem/:dimension`} render={(routeProps) => <OutputQC {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/output-qc`} render={(routeProps) => <OutputQC {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/retrieval-rules`} render={(routeProps) => <RetrievalRulesForm {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/input-qc`} render={(routeProps) => <InputQC {...routeProps} {...props} />}/>
                    <Route path={`${basePath}/spreadsheet`} render={(routeProps) => <VariableRetrievalForm {...routeProps} {...props} />}/>
                    <Route exact path={basePath} render={(routeProps) => <VariableRetrievalForm {...routeProps} {...props} />} />
                    <Route exact path={`${basePath}/*`} component={PageDoesNotExist} />} />
                </Switch>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/VariableRetrieval.js